"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[695],{

/***/ 30695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["default"] = ((0,client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9 9H10c-.4 0-.7-.2-.9-.6-.2-.3-.1-.7.1-1.1l2.5-3c.3-.4 1-.5 1.4-.1.4.3.5 1 .1 1.4L12.1 7H14c.4 0 .7.2.9.5.2.4.1.8-.1 1.1l-2.5 3c-.2.3-.5.4-.8.4-.2 0-.5-.1-.6-.2-.5-.4-.5-1-.2-1.4L11.9 9zm9.1 3c.6 0 1 .4 1 1 0 1.6-1.2 2.9-2.8 3 .5.5.8 1.2.8 2 0 1.7-1.3 3-3 3s-3-1.3-3-3c0-.8.3-1.5.8-2H9.2c.5.5.8 1.2.8 2 0 1.7-1.3 3-3 3s-3-1.3-3-3c0-.8.3-1.5.8-2-1.6-.1-2.8-1.4-2.8-3 0-.6.4-1 1-1s1 .4 1 1 .4 1 1 1h14c.6 0 1-.4 1-1s.4-1 1-1zM6 18c0 .6.4 1 1 1s1-.4 1-1-.4-1-1-1-1 .4-1 1zm10 0c0 .6.4 1 1 1s1-.4 1-1-.4-1-1-1-1 .4-1 1z"
}), "MotorBoard"));


/***/ })

}]);